import { Avatar, Badge, Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Input, List, ListItem, ListItemAvatar, ListItemText, Paper, Select, Typography } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { safeRequestParam } from 'src/utils/Common';
import { loadBaslandiJob,saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  pageStyle: {
    display: 'flex',
    padding: '2px 4px',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  content: {
    minHeight: 430,
  },
}));

function Esleme({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [filter, setFilter] = React.useState('');
  const [EslemeDetay, setEslemeDetay] = React.useState([]);
  let EslemeData = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

  if (!readonly && (!EslemeData || EslemeData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      EslemeData = loadBaslandiJob();
    }
  }

  const [EslemeTipi, setEslemeTipi] = React.useState("0");
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");


  const fetchEsleme = () => {
    setLoading(true);
    axios.get('/GetArtemisFisEsleme/' + FisNo + '/' + (safeRequestParam(filter) || '0') + "/" + EslemeTipi)
      .then(response => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setEslemeDetay([]);
        } else {
          setEslemeDetay(Deger);
        }
        setLoading(false);
      }).catch(error => {
        setEslemeDetay([]);
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  };

  useEffect(() => {
    if (filter.length === 0 || filter.length > 4) {
      fetchEsleme();
    }
    // eslint-disable-next-line
  }, [FisNo]);

  if (EslemeData.length === 0) {
    return null;
  }
  const EslemeTipihandleChange = (event) => {
    setEslemeTipi(event.target.value);
  };

  const setEsleme = (EslenenFisNo, Islem) => {
    confirmAlert({
      message: "Bu işlemi gerçekleştirmek istediğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => setEslemeEvet(EslenenFisNo, Islem)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  const setEslemeEvet = (EslenenFisNo, Islem) => {

    if (Islem === 1 && parseInt(EslemeTipi) === 0) {
      let informationAlert = "Lütfen Eşleme Tipi Seçiniz!..";
      setUyari(informationAlert);
      setOpen(true);
      return;
    }


    setLoading(true);
    const data = {
      FisNo: FisNo,
      EslenenFisNo: EslenenFisNo,
      Tip: EslemeTipi || 0,
      Islem: Islem,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetArtemisFisEsleme', data, config)
      .then(response => {
        const res = response.data;
        setUyari(res.ErrorDescription);
        setOpen(true);
        setLoading(false);
        fetchEsleme();
      }).catch(error => {
        setUyari(error.message);
        setOpen(true);
        setLoading(false);
        fetchEsleme();
      });
  }
  const handleClose = () => {
    setOpen(false);
  };



  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={"Fiş Eşleme"} />
      <Divider />
      <CardContent className={classes.content}>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
        <form
          className={clsx(classes.root, className)}>
          <div className={classes.fields}>
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                fullWidth
                native
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                onChange={EslemeTipihandleChange}
                disabled={readonly}
              >
                <option aria-label="None" value="0">Eşleme Tipi Seçiniz!...</option>
                <option value={1}>Ürün Değişim</option>
                <option value={2}>Klima İç-Dış Ünite</option>
                <option value={3}>Emanet Ürün</option>
                {/* <option value={4}>AEEE</option> */}
                {/* <option value={5}>Düzeltme İptali</option> */}
                <option value={6}>Hurda Ürün</option>
                <option value={8}>Kombi Montaj Kart</option>
                <option value={9}>Klima Alt Yapı</option>
                <option value={10}>Mükerrer Fiş</option>
                <option value={12}>Parça Garanti</option>

                {/* <option value={11}>Yol Ödeme</option> */}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl}>
              <Paper
                className={classes.search}
                elevation={1}>
                <SearchIcon
                  color="primary"
                  onClick={() => { fetchEsleme() }}
                  className={classes.searchIcon} />
                <Divider orientation="vertical" flexItem />
                <Input
                  className={classes.searchInput}
                  disableUnderline
                  onChange={event => { setFilter(event.target.value) }}
                  placeholder={"   FişNo, Telefon, Ad Soyad, Barkod"}
                />


              </Paper>
            </FormControl>
          </div>
          {
            loading ?
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
              :
              <div className={classes.fields}>
                <List className={classes.root}>
                  {Array.isArray(EslemeDetay) && EslemeDetay.map(log => (
                    <div key={log.ESLENEN_FIS_NO}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <div>
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary">
                              {
                                parseInt(log.Eslenmis) === 1
                                  ?
                                  <Badge
                                    overlap="circle"
                                    size="small"
                                    anchorOrigin={{
                                      vertical: 'bottom',
                                      horizontal: 'right',
                                    }}
                                    onClick={() => setEsleme(log.ESLENEN_FIS_NO, 0)}
                                  >
                                    <Avatar style={{ backgroundColor: '#424242', color: 'red' }} ><RemoveCircleIcon /></Avatar>
                                  </Badge>
                                  :
                                  <Badge
                                    overlap="circle"
                                    size="small"
                                    anchorOrigin={{
                                      vertical: 'bottom',
                                      horizontal: 'right',
                                    }}
                                    onClick={() => setEsleme(log.ESLENEN_FIS_NO, 1)}
                                  >
                                    <Avatar style={{ backgroundColor: '#424242', color: "#FF9800" }} ><AddCircleIcon /></Avatar>
                                  </Badge>
                              }
                              { }
                            </Typography>
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          primary={""}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                <b>Tip:</b> {log.ACIKLAMA}
                                <br></br>
                                <b>EşlenenFişNo:</b> {log.ESLENEN_FIS_NO}
                                <br></br>
                                <b>Müşteri:</b> {log.Musteri}
                                <br></br>
                                <b>Marka:</b> {log.Marka}
                                <br></br>
                                <b>Ürün:</b> {log.Urun}
                                <br></br>
                                <b>Yıl/Donem/Seri:</b> {log.UYIL + "/" + log.UDONEM + "/" + log.SERINO}
                                <br></br>
                                <b>Hizmet:</b> {log.Hizmet}
                                <br></br>
                                <b>Adres:</b> {log.Adres}
                              </Typography>
                            </React.Fragment>
                          }
                        />

                      </ListItem>
                      <Divider className={classes.divider} />
                    </div>
                  ))}
                </List>
              </div>
          }
        </form>
      </CardContent>
    </Card>
  );
}

Esleme.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1
  })
)(Esleme);
